var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBotTableOffGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17316C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8078C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17316C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM10.75 15.333C10.7613 15.4246 10.7513 15.5176 10.7207 15.6047C10.6902 15.6918 10.64 15.7707 10.574 15.8352C10.508 15.8998 10.428 15.9482 10.3403 15.9768C10.2525 16.0054 10.1593 16.0133 10.068 16H8.932C8.84067 16.0133 8.74749 16.0054 8.65973 15.9768C8.57197 15.9482 8.49198 15.8998 8.42599 15.8352C8.36 15.7707 8.3098 15.6918 8.27927 15.6047C8.24875 15.5176 8.23873 15.4246 8.25 15.333V8.667C8.23873 8.57539 8.24875 8.48241 8.27927 8.39531C8.3098 8.3082 8.36 8.22931 8.42599 8.16478C8.49198 8.10024 8.57197 8.0518 8.65973 8.02322C8.74749 7.99464 8.84067 7.98669 8.932 8H10.068C10.1593 7.98669 10.2525 7.99464 10.3403 8.02322C10.428 8.0518 10.508 8.10024 10.574 8.16478C10.64 8.22931 10.6902 8.3082 10.7207 8.39531C10.7513 8.48241 10.7613 8.57539 10.75 8.667V15.333ZM15.75 15.333C15.7613 15.4246 15.7513 15.5176 15.7207 15.6047C15.6902 15.6918 15.64 15.7707 15.574 15.8352C15.508 15.8998 15.428 15.9482 15.3403 15.9768C15.2525 16.0054 15.1593 16.0133 15.068 16H13.932C13.8407 16.0133 13.7475 16.0054 13.6597 15.9768C13.572 15.9482 13.492 15.8998 13.426 15.8352C13.36 15.7707 13.3098 15.6918 13.2793 15.6047C13.2487 15.5176 13.2387 15.4246 13.25 15.333V8.667C13.2387 8.57539 13.2487 8.48241 13.2793 8.39531C13.3098 8.3082 13.36 8.22931 13.426 8.16478C13.492 8.10024 13.572 8.0518 13.6597 8.02322C13.7475 7.99464 13.8407 7.98669 13.932 8H15.068C15.1593 7.98669 15.2525 7.99464 15.3403 8.02322C15.428 8.0518 15.508 8.10024 15.574 8.16478C15.64 8.22931 15.6902 8.3082 15.7207 8.39531C15.7513 8.48241 15.7613 8.57539 15.75 8.667V15.333Z",
    fill: "url(#paint0_linear_2721_9649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2721_9649",
    x1: 2,
    y1: 12.0007,
    x2: 22,
    y2: 12.0007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotTableOffGold);
export default __webpack_public_path__ + "static/media/Bot_Table_Off_Gold.f87e45c6b881858976ed591d581bac7e.svg";
export { ForwardRef as ReactComponent };